import Game from "../Game";
import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class RockBullet extends BaseBullet {
  AngleTween: Phaser.Tweens.Tween;
  MovementTween: Phaser.Tweens.Tween;
  moveAngle: number;
  ScaleTween: Phaser.Tweens.Tween;
  initialVelocity: Phaser.Math.Vector2;
  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(group, weapon, indexInWeapon, "", x, y, SPRITESHEET_KEYS.WEAPONS);
    this.setTexture(SPRITESHEET_KEYS.WEAPONS, SPRITESHEET_FRAMES.WEAPONS.ROCK);
    this.initialVelocity = new Phaser.Math.Vector2();
    this.moveAngle = 0;
    this.setScale(2 * GameCore.PixelScale * this.weapon.PArea);
    this.AngleTween = this.scene.tweens.add({
      targets: this,
      angle: 360,
      duration: 1000,
      ease: "Linear",
      repeat: -1,
    });
    this.MovementTween = this.scene.tweens.add({
      targets: this,
      moveAngle: Math.PI,
      duration: 1e3,
      ease: "Linear",
    });
  }
  OnRecycle(): void {
    super.OnRecycle();
    this.setTexture(SPRITESHEET_KEYS.WEAPONS, SPRITESHEET_FRAMES.WEAPONS.ROCK);
    this._speed = 2;
    this.setScale(2 * GameCore.PixelScale * this.weapon.PArea);
    const dot =
      Game.Core.Player.lastFaceDirection.dot(Phaser.Math.Vector2.RIGHT) < 0
        ? -1
        : 1;
    var i = ((45 * dot) / this.weapon.PAmount) * this.indexInWeapon - 90;
    this.scene.physics.velocityFromRotation(
      Phaser.Math.DegToRad(i),
      this.TrueSpeed,
      this.body?.velocity
    );
    this.moveAngle = Phaser.Math.DegToRad(i);
    this.initialVelocity.x = this.body?.velocity.x ?? 0;
    this.initialVelocity.y = Math.max(
      -600,
      (this.body?.velocity.y ?? 1) * this.weapon.PArea - 100
    );
    this.MovementTween = this.scene.tweens.add({
      targets: this,
      moveAngle: Phaser.Math.DegToRad(i + 180 * dot),
      duration: 1500,
      ease: "Linear",
    });
    if (this.ScaleTween) {
      this.ScaleTween.stop();
    }

    this.ScaleTween = this.scene.tweens.add({
      targets: this,
      scale: 0,
      duration: 500,
      delay: this.weapon.PDuration * this.weapon.PArea,
      ease: "Linear",
      onComplete: () => {
        this.DeSpawn();
      },
    });

    // Use Phaser's built-in gravity system for better performance
    if (this.Body) {
      this.Body.setGravityY(350); // Apply downward gravity force
    }
  }
  DeSpawn() {
    super.DeSpawn();
    if (this.ScaleTween) {
      this.ScaleTween.stop();
    }
    if (this.MovementTween) {
      this.MovementTween.stop();
    }
  }
  OnHasHitAnObject(e) {
    if (!e.isDead) {
      this.penetrating--;
      if (this.penetrating <= 0) {
        this.DeSpawn();
      }
    }
  }
}
